import { apiFetch } from '@/shared/api/client'
import { runKitchenSync } from '@/shared/sync/kitchenSync'
import { shouldUseDelmanMock } from '@/features/delman/api/delmanApiMode'

export type CompleteTripRequest = {
  tripId: string
  deviceId: string
  pin: string
}

export type CompleteTripResponse = {
  completed_at: string
  transit_remainder_qty: number
}

const MOCK_PIN = '123456'

function assertPin(pin: string): void {
  if (pin !== MOCK_PIN) {
    throw new Error('PIN salah. Coba lagi atau hubungi Admin HO jika lupa PIN.')
  }
}

async function mockCompleteTrip(): Promise<CompleteTripResponse> {
  await new Promise((r) => setTimeout(r, 500))
  return {
    completed_at: new Date().toISOString(),
    transit_remainder_qty: 12,
  }
}

export async function completeTripDirect(req: CompleteTripRequest): Promise<CompleteTripResponse> {
  if (shouldUseDelmanMock()) {
    assertPin(req.pin)
    return mockCompleteTrip()
  }

  return apiFetch<CompleteTripResponse>(
    `/delivery-trips/${encodeURIComponent(req.tripId)}/complete`,
    {
      method: 'PATCH',
      body: JSON.stringify({ device_id: req.deviceId, pin: req.pin }),
    },
  )
}

export async function completeTrip(req: CompleteTripRequest): Promise<CompleteTripResponse> {
  return runKitchenSync(
    {
      type: 'delman_complete_trip',
      label: `Selesai trip ${req.tripId}`,
      payload: req,
    },
    () => completeTripDirect(req),
    () => ({
      completed_at: new Date().toISOString(),
      transit_remainder_qty: 12,
    }),
  )
}
